(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-supported.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-supported.js');
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectTipsinfoSupport
} = svs.components.tipsen.engine.selectors.engineSelectors;
const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const useIsTipsinfoSupported = () => {
  const tipsinfoSupport = useSelector(selectTipsinfoSupport);
  const shorthandVariables = useMemo(() => {
    const obj = {};
    for (const key in tipsinfoSupport) {
      if (tipsinfoSupport[key] !== undefined) {
        const keyName = "is".concat(capitalizeFirstLetter(key), "Supported");
        obj[keyName] = tipsinfoSupport[key];
      }
    }
    return obj;
  }, [tipsinfoSupport]);
  return _objectSpread({}, shorthandVariables);
};
setGlobal('svs.components.tipsen.hooks.useIsTipsinfoSupported', useIsTipsinfoSupported);

 })(window);